module.exports = __webpack_public_path__ + "static/media/bg_blue_rats.009fb73c.jpg";